import { render, staticRenderFns } from "./player-info.vue?vue&type=template&id=12cbdc06&scoped=true&"
import script from "./player-info.vue?vue&type=script&lang=js&"
export * from "./player-info.vue?vue&type=script&lang=js&"
import style0 from "./player-info.vue?vue&type=style&index=0&id=12cbdc06&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12cbdc06",
  null
  
)

export default component.exports